var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"success"},[_c('img',{staticClass:"success-icon",attrs:{"src":require("@/assets/icon/tip.svg"),"alt":""}}),_c('span',{staticClass:"success-title"},[_vm._v("支付完成")]),_vm._m(0),_c('div',{staticClass:"success-btn",on:{"click":_vm.closePage}},[_vm._v("关闭页面")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"success-msg"},[_c('span',{staticClass:"msg"},[_vm._v("您的付款已成功，请商户确认。")])])
}]

export { render, staticRenderFns }